import clsx from 'clsx'
import ProductBadges from 'snippets/product-badges/product-badges'
import Image from 'snippets/image/image'
import PlpQuickAdd from 'snippets/plp-quick-add/plp-quick-add'
import WishlistButton from 'snippets/wishlist/wishlist-button/wishlist-button'

function ProductCard({
  product,
  isLazy = true,
  textButton = 'Add',
  classProductWrap = 'flex-col',
  classWishlistButton,
  classButton,
  classBadges,
  isDesktop,
  classProductInfo = 'p-3 lg:p-5',
  classProductType = 'text-xs',
  classProductScent = 'text-xs mb-1.5 lg:mb-1',
  classProductTitle = 'mb-0.5 lg:mb-2',
  classProductInfoCustom = 'p-3 lg:p-5',
  customData = {},
  isWishlistCard = false,
  showWishlist = true,
  productBundles = [],
  isDisabledAllButton = false,
  isDisableLinkProduct = false,
  useCustomButtonAtc = false,
  setIsDisabledAllButton = () => {},
  onClickProduct = () => {},
  scrollImageMobile = false
}) {
  const { title, handle, variants, featuredImage: image, images, rolloverImage, tags, available, price } = product
  const { id } = variants[0]
  const hasNoNotifyMeTag = (tags.length > 0 && tags.some((tag) => tag === 'no-notify-me')) || false
  const hasRechargeBundleTag = (tags.length > 0 && tags.some((tag) => tag === 'recharge-bundle')) || false
  const isSampleProduct =
    (tags.length > 0 && tags.some((tag) => tag === 'cart sample' || tag === 'cart samples')) ||
    product.metafields?.seoHidden === '1'
  const productPrice = Number(price) || 0
  const isRenderedAsSample = Object.keys(customData).length > 0
  const hiddenButtonATC = (productPrice === 0 && isSampleProduct === true && !isRenderedAsSample) || false
  const productUrl = `${window.Shopify.routes.root}products/${handle}`
  const productImageSrc = image?.src || window.GM_STATE.shopify.defaultImage
  const classDisableLink = isDisableLinkProduct ? 'pointer-events-none' : ''

  return (
    <div key={id} className={`flex overflow-hidden relative w-full h-full group ${classProductWrap}`}>
      <ProductBadges product={product} currentVariant={variants[0]} classBadges={classBadges} />
      {showWishlist && available && !hasNoNotifyMeTag && (
        <WishlistButton
          product={product}
          className={classWishlistButton}
          variantSelected={product.variants[0].id}
          isWishlistCard={isWishlistCard}
        />
      )}
      <a
        href={productUrl}
        className={`block overflow-hidden relative w-full aspect-4/5 bg-neutral-100 ${classDisableLink} ${scrollImageMobile ? 'scrollbar-hidden lg-max:flex lg-max:overflow-auto lg-max:snap-x lg-max:snap-mandatory' : ''}`}
        onClick={onClickProduct}
      >
        <Image
          isLazy={isLazy}
          url={productImageSrc}
          alt={product.type ? `${product.title} ${product.type}` : product.title}
          width={isDesktop ? 600 : 400}
          height={isDesktop ? 750 : 500}
          sizes={[400, 600]}
          imageClass="size-full"
          className={clsx(
            'aspect-4/5 w-full transition-opacity duration-300',
            (rolloverImage || images.length > 1) ? 'group-hover:opacity-0' : '',
            scrollImageMobile && (rolloverImage || images.length > 1) ? 'lg-max:opacity-100 lg-max:shrink-0 lg-max:snap-center' : ''
          )}
        />
        {(rolloverImage || images.length > 1) && (
          <Image
            isLazy={isLazy}
            url={rolloverImage?.src ?? images[1]?.src}
            alt={product.type ? `${product.title} ${product.type}` : product.title}
            width={isDesktop ? 600 : 400}
            height={isDesktop ? 750 : 500}
            sizes={[400, 600]}
            imageClass="size-full"
            className={clsx('!absolute left-0 top-0 aspect-4/5 w-full opacity-0 transition-opacity duration-300 group-hover:opacity-100',
              scrollImageMobile? 'lg-max:opacity-100 lg-max:!relative lg-max:shrink-0 lg-max:snap-center':''
            )}
          />
        )}
      </a>
      <div className={clsx('flex flex-col flex-1', classProductInfo)}>
        <span className={clsx('flex flex-1 flex-col', useCustomButtonAtc && classProductInfoCustom)}>
          <h2 className={`text-xs font-extrabold uppercase ${classProductTitle}`}>
            <a href={productUrl} className={`block text-xs uppercase w-fit text-neutral-900 ${classDisableLink}`}>
              {title}
            </a>
          </h2>
          {product.metafields?.custom_scent && (
            <p className={`text-neutral-700 ${classProductScent}`}>{product.metafields.custom_scent}</p>
          )}
          {product.type && <p className={`text-neutral-700 ${classProductType}`}>{product.type}</p>}
        </span>
        {!hiddenButtonATC &&
          (hasRechargeBundleTag ? (
            <a
              href={productUrl}
              className="relative mt-auto min-h-[43px] w-full border-t border-neutral-900 px-2 pb-2.5 pt-[13px] text-center text-xs uppercase text-neutral-900 transition-opacity duration-300 xl:opacity-0 xl:focus-visible:opacity-100 group-hover:xl:opacity-100"
            >
              {translate.bundle.viewProductBundle}
            </a>
          ) : (
            <PlpQuickAdd
              product={product}
              productBundles={productBundles}
              currentVariant={variants[0]}
              classButton={classButton}
              textButton={textButton}
              customData={customData}
              hasNoNotifyMeTag={hasNoNotifyMeTag}
              isDisabledAllButton={isDisabledAllButton}
              setIsDisabledAllButton={setIsDisabledAllButton}
              useCustomButtonAtc={useCustomButtonAtc}
            />
          ))}
      </div>
    </div>
  )
}

export default ProductCard
